<template>
  <div class="bb-subsection-list-color">
    <div
      class="bb-subsection-list-color__icon"
      :style="{
        color: `rgba(${item.color}, 1)`,
        background: `rgba(${item.color}, 0.15)`
      }"
      v-html="BackgroundIcon()"
      @click="onOpenColorPicker($event)"
    />
  </div>
</template>

<script>
import { BackgroundIcon } from '@/constants/icon'

export default {
  name: 'SubsectionListColor',
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data: () => ({
    BackgroundIcon
  }),
  methods: {
    onOpenColorPicker (e) {
      const currentItem = {
        ...this.item,
        index: this.index
      }
      this.$emit('onOpenColorPicker', currentItem, e)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../sass/variables";

  .bb-subsection-list-color {
    margin: 0 10px 0 auto;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    cursor: pointer;

    &__icon {
      width: 21px;
      height: 21px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      color: $color-denim;
      background: rgba($color-denim, 0.15);
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Settings/Services/SubsectionList/SubsectionListColor.vue